const leadContactHistorySchema = [
  {
    name: 'contactDate',
    label: 'Contact Date',
    type: 'date',
    required: true,
    showInList: true
  },
  {
    name: 'contactType',
    label: 'Contact Type',
    type: 'multiselect',
    required: true,
    isMulti: false,
    showInList: true
  },
  {
    name: 'attemptNumber',
    label: 'Attempt Number',
    type: 'number',
    required: true,
    showInList: true
  },
  {
    name: 'notes',
    label: 'Notes',
    type: 'editor',
    showInList: false
  }
];

export default leadContactHistorySchema;
